module.exports = __webpack_public_path__ + "img/AMERICA.beddccbd.png";